import classNames from 'classnames';
import { adminClinicTableCeilWidth } from 'constants/adminClinicPage';
import { clinicStatusesDataSource } from 'infrastructure/data-sources/clinic-statuses';

import SlaColumn from './cols/sla';
import InfoColumn from './cols/info';
import s from './cols/styles.module.scss';
import ClinicParentView from './cols/clinicParentView';

import type { Clinic } from 'infrastructure/classes/clinic';

interface IRowsProps {
  isExpanded?: boolean;
  onExpand?: () => void;
  data: Clinic;
}

export const Rows = ({ data, onExpand, isExpanded }: IRowsProps) => {
  const status = clinicStatusesDataSource().findByField('id', data.status);
  return (
    <div className={s['content-wrapper']}>
      <div className={s['row-wrapper']}>
        <ClinicParentView
          className={s['custom-cell']}
          clinic={data}
          onExpand={onExpand}
          isExpanded={isExpanded}
        />

        <div
          className={classNames(s['parent-view-sla'], s['custom-cell'])}
          style={{ width: adminClinicTableCeilWidth.sla }}
        >
          <SlaColumn hours={data.serviceDeliveryThresholds} />
        </div>

        <div
          className={classNames(s.info, s['custom-cell'])}
          style={{ width: adminClinicTableCeilWidth.info }}
        >
          <InfoColumn data={data} />
        </div>

        <span
          data-cy="clinicListTable-providerServiceType"
          className={classNames(s.address, s['custom-cell'])}
          style={{ width: adminClinicTableCeilWidth.serviceType }}
        >
          {data.providerServiceType.join(', ')}
        </span>

        <span
          data-cy="clinicListTable-address"
          className={classNames(s.address, s['custom-cell'])}
          style={{ width: adminClinicTableCeilWidth.address }}
        >
          {data.address}
        </span>

        <span
          data-cy="clinicListTable-status"
          className={classNames(s.status, s['custom-cell'])}
          style={{
            width: adminClinicTableCeilWidth.status,
            color: status?.color,
          }}
        >
          {status?.name}
        </span>
      </div>
    </div>
  );
};
